import { createContext, useContext } from "react";
import type { PlacementsController } from "../hooks/usePlacements.js";

export const PlacementsContext = createContext<PlacementsController | null>(null);

/** The composition's placements controller. Throws outside the provider. */
export function usePlacementsContext(): PlacementsController {
  const v = useContext(PlacementsContext);
  if (!v) {
    throw new Error(
      "usePlacementsContext must be used within a <PlacementsProvider>",
    );
  }
  return v;
}

/**
 * Like {@link usePlacementsContext} but returns null instead of throwing when
 * no provider is mounted — for primitives that OPTIONALLY use the shared
 * service (the board) and must also work in provider-less compositions.
 */
export function usePlacementsContextOptional(): PlacementsController | null {
  return useContext(PlacementsContext);
}
